import React, { useEffect, useState, useRef } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import axios from 'axios';
import { API } from '../utils/Api';
import { useDispatch } from 'react-redux';
import { setActivePickTime, setNewDuration } from '../store/Cart/timeSlice';
import Images from '../utils/Images';
import { Player } from '@lottiefiles/react-lottie-player';
import PickUpOptions from './OrderComponents/PickupOptions';
import { CheckCircleOutline, CropRotateRounded } from '@mui/icons-material';

const PickUpTime = ({ selectedTime }) => {
  const [activeTime, setActiveTime] = useState('');
  const selectedOrderType = localStorage.getItem('selectedOrderType');
  const [makingTimeData, setMakingTimeData] = useState();
  const [newTime, setNewTime] = useState('');
  const [arrivalTimeDurationInMinutes, setArrivalTimeDurationInMinutes] = useState(0);
  const [baseDuration, setBaseDuration] = useState(0);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [fetchingTimes, setFetchingTimes] = useState(true);
  const [initialReadyTime, setInitialReadyTime] = useState('');
  const userHasSelectedTime = useRef(false);
  const token = localStorage.getItem('token');
  const [pickUpOption, setPickUpOption] = useState("DINE_IN");
  const dispatch = useDispatch();

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();
  };

  const updateTimes = async () => {
    setFetchingTimes(true);
    try {
      const responseForMakingTime = await axios.get(`${API.BASE_URL_2}cart/getMakingTime`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const makingTime = parseInt(responseForMakingTime.data.data.makingTimeDuration);
      const currentTime = new Date();
      const newCalculatedTime = new Date(currentTime.getTime() + makingTime * 60000);
      const timeIncrements = [0, 5, 10, 15];

      const slots = timeIncrements.map(increment => {
        const slotTime = new Date(newCalculatedTime.getTime() + increment * 60000);
        return {
          formatted: formatTime(slotTime),
          increment: increment
        };
      });

      setBaseDuration(makingTime);
      setArrivalTimeDurationInMinutes(makingTime);
      setNewTime(formatTime(newCalculatedTime));
      setAvailableSlots(slots);

      // if (selectedOrderType === "DELIVERY") {
      //   // Always set the first slot as the active time for DELIVERY
      //   setActiveTime(slots[0].formatted);
      //   setInitialReadyTime(slots[0].formatted);
      //   // dispatch()
      //   dispatch(setActivePickTime(slots[0].formatted));
      //   dispatch(setNewDuration(makingTime + slots[0].increment));
      // } else {
      //   // Reset active time if a minute has passed since the last selection
      //   if (!userHasSelectedTime.current) {
      //     setActiveTime('');
      //     setInitialReadyTime(slots[0].formatted); 
      //     dispatch(setActivePickTime(''));
      //   } else {
      //     // If a time is already selected, reset it to the first slot if more than a minute has passed
      //     const selectedSlot = slots.find(slot => slot.formatted === activeTime);
      //     if (!selectedSlot) {
      //       setActiveTime(slots[0].formatted);
      //       setInitialReadyTime(slots[0].formatted); 
      //       dispatch(setActivePickTime(slots[0].formatted));
      //       dispatch(setNewDuration(makingTime + slots[0].increment));
      //     }
      //   }
      // }
      setActiveTime(slots[0].formatted);
      setInitialReadyTime(slots[0].formatted);
      // dispatch()
      dispatch(setActivePickTime(slots[0].formatted));
      dispatch(setNewDuration(makingTime + slots[0].increment));
      setFetchingTimes(false);
    } catch (error) {
      console.error('Error in making time API', error.response);
    } finally {
      setFetchingTimes(false);
    }
  };

  // const updateTimes = async () => {
  //   try {
  //     const responseForMakingTime = await axios.get(`${API.BASE_URL}cart/getMakingTime`, {
  //       headers: { Authorization: `Bearer ${token}` }
  //     });
  //     const makingTime = parseInt(responseForMakingTime.data.data.makingTimeDuration);
  //     const currentTime = new Date();
  //     const newCalculatedTime = new Date(currentTime.getTime() + makingTime * 60000);
  //     const timeIncrements = [0, 5, 10, 15];

  //     const slots = timeIncrements.map(increment => {
  //       const slotTime = new Date(newCalculatedTime.getTime() + increment * 60000);
  //       return {
  //         formatted: formatTime(slotTime),
  //         increment: increment
  //       };
  //     });

  //     setBaseDuration(makingTime);
  //     setArrivalTimeDurationInMinutes(makingTime);
  //     setNewTime(formatTime(newCalculatedTime));
  //     setAvailableSlots(slots);

  //     // Reset active time if a minute has passed since the last selection
  //     if (!userHasSelectedTime.current) {
  //       setActiveTime('');
  //       setInitialReadyTime(slots[0].formatted); 
  //       dispatch(setActivePickTime(''));
  //     } else {
  //       // If a time is already selected, reset it to the first slot if more than a minute has passed
  //       const selectedSlot = slots.find(slot => slot.formatted === activeTime);
  //       if (!selectedSlot) {
  //         setActiveTime(slots[0].formatted);
  //         setInitialReadyTime(slots[0].formatted); 
  //         dispatch(setActivePickTime(slots[0].formatted));
  //         dispatch(setNewDuration(makingTime + slots[0].increment));
  //       }
  //     }

  //   } catch (error) {
  //     console.error('Error in making time API', error.response);
  //   }
  // };

  useEffect(() => {
    updateTimes();
    const intervalId = setInterval(updateTimes, 60000);
    return () => clearInterval(intervalId);
  }, []);

  const handleClick = (time, increment) => {
    userHasSelectedTime.current = true;
    const newDuration = baseDuration + increment;
    setActiveTime(time.formatted);
    console.log('Selected time:', time.formatted, 'with total duration:', newDuration);
    setArrivalTimeDurationInMinutes(newDuration);
    dispatch(setActivePickTime(time.formatted));
    dispatch(setNewDuration(newDuration));
  };

  const OptionPill = ({ value, label }) => {
    const selected = pickUpOption === value;

    return (
      <Box
        onClick={() => setPickUpOption(value)}
        sx={{
          cursor: "pointer",
          height: 30,
          borderRadius: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          border: selected ? "2px solid #0EA5E9" : "2px solid #0EA5E9",
          background: selected
            ? "linear-gradient(180deg, #2BB6FF 0%, #0EA5E9 100%)"
            : "#fff",
          color: selected ? "#fff" : "#0B3B4A",
          fontWeight: 600,
          userSelect: "none",
        }}
      >
        {selected && (
          <Box
            sx={{
              position: "absolute",
              left: 0,
              width: 30,
              height: 30,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircleOutline sx={{ fontSize: 28, color: "#0EA5E9" }} />
          </Box>
        )}

        <Typography sx={{ fontSize: 14, fontWeight: 400 }}>
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Box className="pickUpTimeComponent">
        {fetchingTimes ? (
          <Box className="secondBg" sx={{ textAlign: 'center' }}>
            {/* <img src={Images.timeLoading} style={{ height: '80px' }} /> */}
            <Player autoplay loop={true} keepLastFrame={true} src={Images.timeLoading} style={{ height: '100px' }} />
            <Typography className='availableSlot'>Fetching Available Time Slots</Typography>
          </Box>
        ) : (
          <Box className="secondBg">
            <Box className="secondBox border-bottom">
              <Typography className="pickUpText">Set Up Pick Up Time |</Typography>
              <Typography className='readyTime'>Ready Time: <span style={{ fontWeight: '600' }}>{activeTime}</span> </Typography>
            </Box>
            <Typography className='availableSlot'>Available Pick Up Slots</Typography>
            <Box className="timeSlots">
              <Grid container spacing={1}>
                {availableSlots.map((slot, index) => (
                  <Grid item xs={3} key={index}>
                    <Typography
                      className={`time ${activeTime === slot.formatted ? 'active' : ''}`}
                      onClick={() => handleClick(slot, slot.increment)}
                      sx={{ textAlign: 'center' }}
                    >
                      {slot.formatted}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        )}
        <Box className="pickUpOptionsComponent">
          <Typography className="pickUpText">Pick Up Options </Typography>
          <Grid container spacing={2} pt={1}>
            <Grid item xs={6} sm={6}>
              <OptionPill value="DINE_IN" label="Dine-In" />
            </Grid>

            <Grid item xs={6} sm={6}>
              <OptionPill value="TAKE_AWAY" label="Take-Away" />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default PickUpTime;
